import AircraftCard from './AircraftCard';

export default AircraftCard;
